export default __webpack_public_path__ + "static/media/background_start.3ff5ce09.jpg";